$(document).ready(function() {
    $(".form_container").hide();
    $("#apply").on("click", function() {
        $(".form_container").slideToggle( "900", function(){
            $("html, body").stop().animate({scrollTop: $(".form_container").offset().top - 100}, 1000, "swing");
        });
    });
  });